export default __webpack_public_path__ + "static/media/HEADERS-Agromart.7c2df77a.png";